<template>
  <AppContent
    :resourcePath="resourcePath"
    :headers="headers"
    :title="title"
    :subject="subject"
    item-key="name"
    @table-item-delete="onTableItemDelete"
    :table-props="{ 
      downloadable: false, 
      itemKey: 'name', headers,
      itemActions: ['edit', 'delete']
      }"
    >
      <template #form="slotProps">
        <PermissionForm
          ref="form"
          v-bind="slotProps"
        /> 
      </template>
  </AppContent>
</template>

<script>
import AppContent from './AppContent'
import DeletePermissionMessage from './role/DeletePermissionMessage'
import PermissionForm from './PermissionForm'

export default {
  name: 'Permissions',
  components: {
    AppContent,
    PermissionForm
  },

  data() {
    return {
      resourcePath: 'permissions',
      title: 'Permissions',
      subject: 'Permission',
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          filterable: false
        }
      ],
    }
  },

  methods: {

    onTableItemDelete(item) {
      this.$store.dispatch('prompt/confirm', {
        title: 'Delete confirmation',
        component: DeletePermissionMessage,
        data: item
      }).then(response => {
        if (response)
          this.$store.dispatch(`${this.resourcePath}/delete`, item)
      })
    }

  }

}
</script>
